import { Box, Skeleton } from '@mui/material';

const AppCardSkeleton = () => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                minHeight: { xs: 248, sm: 300, md: 330 },
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 2,
                overflow: 'hidden'
            }}
        >
            <Skeleton
                variant="rectangular"
                sx={{
                    width: '100%',
                    aspectRatio: '1',
                    flexShrink: 0,
                    borderRadius: 0
                }}
                animation="wave"
            />
            <Box
                sx={{
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                    minHeight: 0
                }}
            >
                <Skeleton variant="text" animation="wave" width="100%" height={36} sx={{ mb: 0.5, flexShrink: 0 }} />
                <Skeleton variant="text" animation="wave" width="55%" height={18} sx={{ mb: 0.25, flexShrink: 0 }} />
                <Skeleton variant="text" animation="wave" width="70%" height={16} sx={{ flexShrink: 0 }} />
                <Box sx={{ mt: 'auto', pt: 0.5, minHeight: 32, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Skeleton variant="text" animation="wave" width="45%" height={16} />
                    <Skeleton variant="circular" animation="wave" width={28} height={28} />
                </Box>
            </Box>
        </Box>
    );
};

export default AppCardSkeleton;
